import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    style: style,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38462 12.9226C7.38462 15.4711 9.45 17.538 12 17.538C14.5485 17.538 16.6154 15.4711 16.6154 12.9226C16.6154 10.3734 14.5485 8.30722 12 8.30722C9.45 8.30722 7.38462 10.3734 7.38462 12.9226ZM6 12.9226C6 9.60911 8.68575 6.92261 12 6.92261C15.3135 6.92261 18 9.60911 18 12.9226C18 16.2354 15.3135 18.9226 12 18.9226C8.68575 18.9226 6 16.2354 6 12.9226ZM1.38462 21.9126C0.58774 21.9126 0 21.2697 0 20.4792V6.14647C0 5.35454 0.58774 4.61493 1.38462 4.61493H5.53846L6.25962 3.27905C6.25962 3.27905 6.90505 1.8457 7.70192 1.8457H16.2981C17.0942 1.8457 17.7404 3.27905 17.7404 3.27905L18.4615 4.61493H22.6154C23.4115 4.61493 24 5.35454 24 6.14647V20.4792C24 21.2697 23.4115 21.9126 22.6154 21.9126H1.38462Z",
    fill: "black",
    fillOpacity: "0.26"
  }));
};
export default SVGComponent;